<script>
import Multiselect from 'vue-multiselect'
import { ValidationProvider } from 'vee-validate'

export default {
  name: 'FormSelector',
  components: {
    Multiselect,
    ValidationProvider,
  },
  props: {
    value: {
      required: false,
      default: () => '',
    },
    multiple: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    label: {
      type: String,
      required: false,
      default: '',
    },
    name_option: {
      type: String,
      required: false,
      default: 'name',
    },
    description: {
      type: String,
      required: false,
      default: '',
    },
    fetchOptions: {
      type: Function,
      required: false,
    },
    vid: {
      type: String,
    },
    rules: {
      type: [Object, String],
      default: '',
    },
    drfProvider: {
      type: Boolean,
      required: false,
      default: true,
    },
    opts: {
      type: Array,
      required: false,
      default: () => [],
    },
    reqParams: {
      type: Object,
      required: false,
    },
    withOutBorder: {
      type: Boolean,
      default: false,
    },
    search: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      options: [],
      loadingOptions: false,
      optionsMounted: true,
      optionsCache: [],
      values: []
    }
  },
  computed: {
    // ...authComputed,
    inputVal: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },

  mounted: function() {
    let context = this
    if (this.drfProvider) {
      context.populateOptions()
    } else {
      this.options = this.opts
    }
  },

  methods: {
    populateOptions(searchQuery) {
      let context = this
      console.log(this.value)
      console.log(this.inputVal)
      context.loadingOptions = true
      let reqParams = context.$select_params(searchQuery)
      let promise
      if (this.reqParams) {
        promise = context.fetchOptions(
          `?${this.reqParams.key}=${this.reqParams.value}`
        )
      } else {
        promise = context.fetchOptions(reqParams)
      }
      return promise
        .then((data) => {
          console.log(data)
          let listOptions = []
          console.log(data)
          data.results.forEach((opt) => {
            listOptions.push({
              id: opt.id,
              name: opt[context.name_option] || opt.id,
            })
          })
          context.options = listOptions
          context.loadingOptions = false
          context.optionsMounted = true
        })
        .catch((error) => {
          context.$axios_error_noty(error, context)
          context.loadingOptions = false
          context.optionsMounted = true
        })
    },

    asyncFindOptions: _.debounce(function(searchQuery) {
      this.populateOptions(searchQuery)
    }, 600),

    labelOfOption(opt) {
      let context = this
      let optionFound = context.options.find((x) => x.id === opt)
      if (!optionFound) {
        let cacheFound = context.optionsCache.find((x) => x.id === opt)
        return cacheFound
          ? cacheFound.name
          : context.optionsMounted
          ? `${'label_not_found'}: ${opt}`
          : ''
      } else {
        if (context.inputVal === opt) {
          if (!context.optionsCache.find((x) => x.id === opt)) {
            context.optionsCache.push(optionFound)
          }
        }
        return optionFound.name
      }
    },
  },
}
</script>

<template>
  <ValidationProvider :vid="vid" :name="$attrs.name" :rules="rules">
    <b-form-group
      :label="label"
      class="mb-1"
      slot-scope="{ errors }"
      v-bind="$attrs"
    >
      <div
        class="rounded d-flex border-primary"
        :class="[
          errors[0] && !withOutBorder
            ? 'border border-danger'
            : inputVal && !withOutBorder
            ? 'border border-success'
            : null,
        ]"
      >
        <slot name="prepend"> </slot>
        <Multiselect
          v-if="drfProvider"
          v-model="inputVal"
          :multiple="multiple"
          :options="options.map((x) => x.id)"
          :custom-label="(opt) => labelOfOption(opt)"
          :loading="loadingOptions"
          :internal-search="search"
          select-label="Seleccionar"
          selected-label="Seleccionado"
          deselect-label="Remover"
          :placeholder="label"
          @search-change="asyncFindOptions"
        >
        </Multiselect>
      

        <Multiselect
          v-else-if="!drfProvider"
          v-model="inputVal"
          :multiple="multiple"
          :options="options.map((x) => x.value)"
          :custom-label="(opt) => options.find((x) => x.value === opt).name"
          :internal-search="false"
          select-label="Seleccionar"
          selected-label="Seleccioando"
          deselect-label="Remover"
          :placeholder="label"
        >
        </Multiselect>
      </div>
      <span class="text-danger">{{ errors[0] }}</span>
      <!-- <span class="typo__label form__label" v-show="errors">{{ errors[0] }}</span> -->
    </b-form-group>
  </ValidationProvider>
</template>
<style lang="scss">
.multiselect__tags {
  border-color:#121a79;
// 	min-height: 38px;
// 	display: block;
// 	max-height: 30px;
// 	padding: 6px 40px 0 8px;
// 	border-radius: 5px;
// 	border: 1px solid #0570a7;
// 	background: #fff;
// 	font-size: 14px
}
</style>
